import { useState } from 'react'
import toast from 'react-hot-toast'
import VoiceSectionPage from '@/components/layout/VoiceSectionPage'
import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/supabaseClient'

export default function CreditosPage() {
  const { getProfileId } = useAuth()
  const profileId = getProfileId()

  const MIN_RECHARGE = 300
  const [credits, setCredits] = useState(MIN_RECHARGE)
  const [loading, setLoading] = useState(false)

  async function comprarCreditos(e) {
    e.preventDefault()
    if (!profileId) {
      toast.error('Perfil não encontrado.')
      return
    }

    const amount = Number(credits)
    if (!Number.isFinite(amount) || amount < MIN_RECHARGE) {
      toast.error(`A recarga mínima é de R$ ${MIN_RECHARGE.toFixed(2)}.`)
      return
    }

    setLoading(true)
    const { data, error } = await supabase.functions.invoke('create-stripe-checkout', {
      body: {
        amount,
        credits: amount,
        profile_id: profileId,
      },
    })
    setLoading(false)

    if (error) {
      toast.error(error.message || 'Erro ao iniciar compra de créditos.')
      return
    }

    if (!data?.checkout_url) {
      toast.error('URL de checkout não recebida.')
      return
    }

    window.location.href = data.checkout_url
  }

  return (
    <VoiceSectionPage
      title="Comprar créditos"
      description="Compre créditos para sua operação de voz. Pode compartilhar saldo com o WappDesk conforme sua regra comercial."
    >
      <form
        onSubmit={comprarCreditos}
        className="max-w-lg rounded-xl border border-border bg-card p-5 shadow-sm space-y-4"
      >
        <label className="block text-sm font-medium text-foreground">
          Quantidade de créditos
          <input
            type="number"
            min={MIN_RECHARGE}
            step="50"
            value={credits}
            onChange={(e) => setCredits(Number(e.target.value || 0))}
            className="mt-2 h-11 w-full rounded-lg border border-input bg-background px-3"
          />
        </label>

        <p className="text-xs text-muted-foreground">Recarga mínima: R$ 300,00.</p>
        <p className="text-sm text-muted-foreground">
          Total estimado: <span className="font-semibold text-foreground">R$ {credits.toFixed(2)}</span>
        </p>

        <button
          type="submit"
          disabled={loading}
          className="inline-flex min-h-[44px] w-full items-center justify-center rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-50"
        >
          {loading ? 'Abrindo checkout...' : 'Comprar créditos'}
        </button>
      </form>
    </VoiceSectionPage>
  )
}
